import React from 'react'
import EmberNotes from '../components/EmberNotes'
import ScorchNotes from '../components/ScorchNotes'

const GraphicNov = () => {
    return (
    <>
        <EmberNotes />
        <ScorchNotes />
    </>
  )
}

export default GraphicNov